import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Typography,
  Box,
  useMediaQuery,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
import userActions from "./actions";

import { Grid } from "@material-ui/core";
import { UserRole } from "./constants";

const useStyles = makeStyles((theme) => ({
  card: {
    background: "#C6CCDD 0% 0% no-repeat padding-box",
    borderRadius: 8,
    opacity: 1,
  },
  cardHeader: {
    color: "#646464",
  },
}));

const UsersOverview = () => {
  const { role } = useSelector((state) => state.auth);
  const { breakDown } = useSelector((state) => state.user);
  const { openCreateDialog, loadBreakDown } = userActions();
  const classes = useStyles();

  useEffect(() => {
    loadBreakDown();
  }, [loadBreakDown]);
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <>
      <Box my={2}>
        <Grid
          container
          justify={matches ? "space-between" : "center"}
          alignItems="center"
        >
          {!matches &&
            (role === UserRole.SUPERADMIN || role === UserRole.ADMIN) && (
              <IconButton
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => openCreateDialog()}
              >
                <AddCircleRoundedIcon fontSize="large" />
              </IconButton>
            )}
          <Typography variant="h5">Members</Typography>

          {matches &&
            (role === UserRole.SUPERADMIN || role === UserRole.ADMIN) && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => openCreateDialog()}
              >
                Invite Member to SVP
              </Button>
            )}
        </Grid>
      </Box>
      <Grid container justify="flex-start">
        {[
          { h: "Members", c: breakDown["members"] },
          {
            h: "Super User",
            c: breakDown["super_users"],
          },
          {
            h: "Pending Approval",
            c: breakDown["pending_approval"],
          },
        ].map((value) => (
          <Grid item xs={4} md={2} key={value["h"]}>
            <Box
              mr={1}
              p={matches ? 2 : 1}
              height={matches ? "auto" : "50px"}
              className={classes.card}
            >
              <Typography
                variant={matches ? "subtitle2" : "caption"}
                color="secondary"
                gutterBottom
              >
                {value.h}
              </Typography>
              <Typography variant={matches ? "h5" : "subtitle2"} gutterBottom>
                {value.c}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default UsersOverview;
